// extracted by mini-css-extract-plugin
export var balNavigationPopoverButton = "LanguageSwitch-module--bal-navigation-popover-button--b7e3f";
export var languageButton = "LanguageSwitch-module--language-button--66e5d";
export var languageTriggerButton = "LanguageSwitch-module--language-trigger-button--5338e";
export var languageswitcher = "LanguageSwitch-module--languageswitcher--8a9ef";